'use client';

import { useState } from 'react';

type MediaImageProps = {
  src: string | null | undefined;
  alt: string;
  className?: string;
  imgClassName?: string;
  eager?: boolean;
  rounded?: string;
};

export function MediaImage({
  src,
  alt,
  className,
  imgClassName,
  eager = false,
  rounded,
}: MediaImageProps) {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  const showImage = Boolean(src) && !failed;

  return (
    <div
      className={`relative h-full w-full overflow-hidden bg-white/[0.04] ${className ?? ''}`}
      style={rounded ? { borderRadius: rounded } : undefined}
    >
      {!loaded && !failed ? (
        <div
          className="absolute inset-0 animate-pulse bg-gradient-to-br from-white/[0.07] via-white/[0.03] to-white/[0.07]"
          aria-hidden
        />
      ) : null}
      {showImage ? (
        /* eslint-disable-next-line @next/next/no-img-element */
        <img
          src={src ?? undefined}
          alt={alt}
          loading={eager ? 'eager' : 'lazy'}
          decoding="async"
          onLoad={() => setLoaded(true)}
          onError={() => setFailed(true)}
          className={`h-full w-full object-cover transition-opacity duration-500 ${
            loaded ? 'opacity-100' : 'opacity-0'
          } ${imgClassName ?? ''}`}
        />
      ) : null}
    </div>
  );
}
